import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { initAnalytics } from '@/lib/analytics'
import './index.css'

// 유입 경로 기록 + Amplitude 초기화 (키가 없으면 유입 기록만 하고 전송하지 않는다)
initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
